export default [
    {
        path: '/bills/cafeBazar',
        name: 'billsCafeBazar',
        component: () => import('@/views/menu/bills/cafebazar.vue'),
        meta: {
            pageTitle: 'مدیریت کافه بازار',
            action: 'show',
            resource: 'UserManager',
        },
    },
     {
        path: '/bills/zarinPal',
        name: 'billsZarinPal',
        component: () => import('@/views/menu/bills/zarinPal.vue'),
        meta: {
            pageTitle: 'مدریت زرین پال',
            action: 'show',
            resource: 'UserManager',
        },
    },


    ]